module.exports = __webpack_public_path__ + "static/media/Master_Mix.0e16d054.svg";